<template>
  <div class="footer">
    <p class="title">联系方式</p>
    <p class="message">0512-65929315<span>|</span>QQ:1048789942<span>|</span>service@raipeng.com</p>
    <p class="address">地址：苏州市工业园区独墅湖崇文路创意产业园7栋8楼</p>

    <div class="contents">
      <img class="ic-qrcode" src="../assets/imgs/mobile/ic-qrcode.png"/>
      <div class="right_part">
        <p class="name">瑞鹏信息技术有限公司公众号</p>
        <p class="text">Copyright © 2013-2019 www.raipeng.com</p>
        <p class="text">All Rights Reserved 苏州瑞鹏信息技术有限公司版权所有</p>
        <p class="text" @click="goToBeian">苏ICP备13034509号-2 苏B2-20130343</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {}
    },
    methods: {
      goToBeian() {
        window.location.href = "https://beian.miit.gov.cn/"
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .footer {
    width: 100%;
    padding: 0 0.25rem;
    height: 3.56rem;
    background:rgba(28,28,28,1);
    box-sizing: border-box;

    .title {
      font-size:0.24rem;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:0.3rem;
      padding: 0.15rem 0 0.03rem;
    }
    .message {
      font-size:0.24rem;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(45,182,255,1);
      margin: 0.15rem 0;

      span {
        color: #fff;
        margin: 0 0.18rem;
      }
    }
    .address {
      font-size:0.2rem;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
    }

    .contents {
      margin-top: 0.4rem;

      .ic-qrcode {
        width: 1.44rem;
        height: 1.44rem;
        display: inline-block;
        float: left;
      }

      .right_part {
        width: 4.8rem;
        margin-left: 0.3rem;
        display: inline-block;
        float: left;
        .name {
          font-size:0.28rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:0.36rem;
        }
        .text {
          font-size:0.16rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:0.36rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mComponents/Footer.vue